import {useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import EndPointService from "../services/endpoint";

type RemoverProps = { id: number; onRemove?: () => void }

enum ACTION_STATUS {
    NO_ACTION = 'NO_ACTION',
    IN_PROGRESS = 'IN_PROGRESS',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
}


export default function Remover({id, onRemove}: RemoverProps) {
    const [status, setStatus] = useState<ACTION_STATUS>(ACTION_STATUS.NO_ACTION);
    function remove() {
        setStatus(ACTION_STATUS.IN_PROGRESS);
        EndPointService
            .remove(id)
            .then(() => {
                setStatus(ACTION_STATUS.SUCCESS);
                onRemove && onRemove();
            })
            .catch(() => {
                setStatus(ACTION_STATUS.ERROR);
            });
    }
    return (
        <span className={"remover status-"+status}>
            {
                status === ACTION_STATUS.IN_PROGRESS ? <FontAwesomeIcon icon="spinner" spin /> 
                : <FontAwesomeIcon icon="trash" onClick={() => remove()}/>
            }
            
        </span>
    )
}